import { useAuth } from "@/App";
export { API, err, fmtD, inp } from "@/components/crm/lohn/Krankmeldungen";

export const sel = "h-10 rounded-lg border border-slate-200 px-2 text-sm bg-white";
export const ta = "w-full rounded-lg border border-slate-200 px-3 py-2 text-sm min-h-[80px]";
export const btnP = "h-10 px-4 rounded-lg bg-slate-900 text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-1 whitespace-nowrap";
export const btnS = "h-10 px-3 rounded-lg border border-slate-300 bg-white text-sm font-semibold inline-flex items-center gap-1 whitespace-nowrap";

export function useH() {
  const { user } = useAuth();
  return { user, H: { headers: { Authorization: `Bearer ${user.token}` } }, admin: user.role === "admin" };
}

export const fileToBase64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result.split(",")[1]); r.onerror = rej; r.readAsDataURL(file); });

export const Pill = ({ cls, children, testId }) => <span data-testid={testId} className={`px-2 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${cls}`}>{children}</span>;

export function Karte({ titel, children, aktion, testId }) {
  return <div className="bg-white rounded-2xl border border-slate-200 p-4 md:p-5" data-testid={testId}>
    {(titel || aktion) && <div className="flex flex-wrap items-center justify-between gap-2 mb-3">{titel && <h2 className="font-bold text-slate-900">{titel}</h2>}{aktion}</div>}
    {children}
  </div>;
}

export function Feld({ label, children, hinweis }) {
  return <label className="block text-sm"><span className="text-xs font-semibold text-slate-600">{label}</span>{children}{hinweis && <span className="block text-[11px] text-slate-400 mt-0.5">{hinweis}</span>}</label>;
}

export function oeffnePdf(url, user) {
  return fetch(url, { headers: { Authorization: `Bearer ${user.token}` } }).then(async (r) => { if (!r.ok) throw new Error("PDF nicht verfügbar"); const b = await r.blob(); window.open(URL.createObjectURL(b), "_blank"); });
}
